import { getSafeLabel } from 'organisms/QuestionConditionalLogic/utils'
import React from 'react'

export function DropdownOptionText({ choice, questionType, isOpinionScale }) {
  const safeLabel = getSafeLabel(choice)

  if (!isOpinionScale) {
    return <span>{safeLabel}</span>
  }

  if (questionType === 'multipleChoice') {
    return (
      <span>
        <span>{safeLabel}</span>
      </span>
    )
  }

  if (questionType === 'star') {
    return <span>{`${choice.value} Star${choice.value == 1 ? '' : 's'}`}</span>
  }

  if (questionType === 'slider') {
    const isShowLabel = choice.value == 0 || choice.value == 10
    return (
      <>
        <span>{choice.value}</span>
        {isShowLabel && <span> - {safeLabel}</span>}
      </>
    )
  }

  if (questionType === 'rating_scale_minmax') {
    const isShowLabel = choice.value == 1 || choice.value == 7
    return (
      <>
        <span>{choice.value}</span>
        {isShowLabel && <span> - {safeLabel}</span>}
      </>
    )
  }

  return null
}



// WEBPACK FOOTER //
// ./src/organisms/QuestionConditionModal/DropdownOptionText.tsx